import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import { menuKeyForPath, firstAllowedPath, getSidebarMenu } from '../utils/menuByIndustry'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    component: () => import('../views/Login.vue'),
    meta: { public: true },
  },
  {
    path: '/',
    component: () => import('../components/Layout.vue'),
    redirect: '/workbench',
    children: [
      {
        path: 'workbench',
        name: 'Workbench',
        component: () => import('../views/dashboard/Workbench.vue'),
        meta: { title: '门店收银', menuKey: 'workbench' },
      },
      {
        path: 'settings/print',
        name: 'PrintSettings',
        component: () => import('../views/settings/PrintSettings.vue'),
        meta: { title: '打印设置', menuKey: 'printSettings' },
      },
      {
        path: 'settings/voice',
        name: 'VoiceSettings',
        component: () => import('../views/settings/VoiceSettings.vue'),
        meta: { title: '语音播报', menuKey: 'voiceSettings' },
      },
      {
        path: 'appointment',
        name: 'Appointment',
        component: () => import('../views/appointment/Index.vue'),
        meta: { title: '预约管理', menuKey: 'appointment' },
      },
      {
        path: 'shop/config',
        name: 'ShopConfig',
        component: () => import('../views/shop/Config.vue'),
        meta: { title: '预约与行业', menuKey: 'shopConfig' },
      },
      {
        path: 'platform/shops',
        name: 'PlatformShops',
        component: () => import('../views/platform/Shops.vue'),
        meta: { title: '门店管理', menuKey: 'platformShops', superAdmin: true },
      },
      {
        path: 'platform/admins',
        name: 'PlatformAdmins',
        component: () => import('../views/platform/Admins.vue'),
        meta: { title: '账号管理', menuKey: 'platformAdmins', superAdmin: true },
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/dashboard/Index.vue'),
        meta: { title: '数据概览', menuKey: 'dashboard' },
      },
      {
        path: 'knowledge',
        name: 'Knowledge',
        component: () => import('../views/knowledge/Index.vue'),
        meta: { title: '知识库管理', menuKey: 'knowledge' },
      },
      {
        path: 'knowledge/edit/:id?',
        name: 'KnowledgeEdit',
        component: () => import('../views/knowledge/Edit.vue'),
        meta: { title: '编辑文档', menuKey: 'knowledge' },
      },
      { path: 'customers', component: () => import('../views/customer/Index.vue'), meta: { title: '客户档案', menuKey: 'customers' } },
      {
        path: 'session-cards',
        name: 'SessionCards',
        component: () => import('../views/session-card/Index.vue'),
        meta: { title: '次卡管理', menuKey: 'sessionCards' },
      },
      {
        path: 'chat',
        name: 'Chat',
        component: () => import('../views/chat/Index.vue'),
        meta: { title: '对话记录', menuKey: 'chat' },
      },
      {
        path: 'shop/theme',
        name: 'ShopTheme',
        component: () => import('../views/shop/Theme.vue'),
        meta: { title: '主题与首页', menuKey: 'shopTheme' },
      },
      {
        path: 'mall',
        name: 'Mall',
        component: () => import('../views/mall/Index.vue'),
        meta: { title: '商城管理', menuKey: 'mall' },
      },
      {
        path: 'lottery',
        name: 'Lottery',
        component: () => import('../views/lottery/Index.vue'),
        meta: { title: '活动抽奖', menuKey: 'lottery' },
      },
      {
        path: 'pet-service-cards',
        name: 'PetServiceCards',
        component: () => import('../views/pet-service-card/Index.vue'),
        meta: { title: '宠物信息卡', menuKey: 'petServiceCards' },
      },
      {
        path: 'payments',
        name: 'Payments',
        component: () => import('../views/pay/Index.vue'),
        meta: { title: '支付流水', menuKey: 'payments' },
      },
    ],
  },
  { path: '*', redirect: '/' },
]

const router = new VueRouter({ mode: 'history', routes })

function resolveMenuGuardContext() {
  const user = store.state.userInfo || {}
  const ctx = store.state.shopContext || {}
  const isSuper = user.role === 'super_admin'
  return {
    isSuper,
    industry: ctx.industry || 'barber',
    menuKeys: ctx.adminMenuKeys || [],
  }
}

// 路由守卫：未登录跳登录页；无菜单权限则重定向
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (!to.meta.public && !token) {
    next('/login')
    return
  }
  if (to.matched.some(r => r.meta.superAdmin)) {
    let user = {}
    try {
      user = JSON.parse(localStorage.getItem('userInfo') || '{}')
    } catch (e) {}
    if (user.role !== 'super_admin') {
      next('/workbench')
      return
    }
  }
  if (!to.meta.public) {
    const menuKey = to.meta.menuKey || menuKeyForPath(to.path)
    if (menuKey) {
      const { isSuper, industry, menuKeys } = resolveMenuGuardContext()
      const allowed = getSidebarMenu({ industry, isSuper, menuKeys })
      if (!allowed.some((m) => m.key === menuKey)) {
        next(firstAllowedPath(menuKeys, isSuper))
        return
      }
    }
  }
  next()
})

router.afterEach((to) => {
  if (to.meta && to.meta.public) {
    document.documentElement.classList.remove('admin-has-shell')
  } else {
    document.documentElement.classList.add('admin-has-shell')
  }
})

export default router
